import {Pipe, PipeTransform} from "@angular/core";
import {DomSanitizer} from "@angular/platform-browser";



@Pipe({name: "safeStyle"})
export class SafeStyle implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {
  }
  transform(value: string) {
    return this.sanitized.bypassSecurityTrustStyle(value);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/safeStyle.ts